var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid mb-2 mb-md-3" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "div",
            { staticClass: "bg-greige d-flex p-1 align-items-center" },
            [
              _c("span", {
                staticClass:
                  "icon icon-phone-fund-euro text-primary font-size-30 px-2",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "h4 mb-0 mw-100 mobile-text-center" }, [
                _c("span", {
                  staticClass: "offer-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.onBoardingOfferDescriptionText),
                  },
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "break-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.onBoardingYearlyDiscountsInfoText),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary ms-auto flex-shrink-0 d-flex justify-content-center align-items-center ms-2 me-2 w-200 mobile-max-width",
                  attrs: {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#" + _vm.discountAdvantagesPopin.id,
                    "data-oevent-category": "ouverture_popin",
                    "data-oevent-action": "en_savoir_plus",
                    "data-oevent-label": "avantages_remise_popin",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.buttonLabel) +
                      "\n                "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("discount-advantages-popin", {
            attrs: { "dto-from-object": _vm.discountAdvantagesPopin },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }